<template>
  <v-row class="user_register_container">
    <v-col cols="12" xs="12">
      <v-form>
        <form-message v-if="message" :message="message" @close="messageClose">
        </form-message>
        <v-row>
          <v-col cols="12" class="user_register_container_title">
            Registra tus datos
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              filled
              label="Primer nombre"
              v-model="firstName"
              required
              :error-messages="firstNameError"
              @input="$v.firstName.$touch()"
              @blur="$v.firstName.$touch()"
              @keypress="isLetter($event)"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              filled
              label="Segundo nombre (opcional)"
              v-model="secondName"
              @keypress="isLetter($event)"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              filled
              label="Apellido paterno"
              v-model="firstLastName"
              required
              :error-messages="firstLastNameError"
              @input="$v.firstLastName.$touch()"
              @blur="$v.firstLastName.$touch()"
              @keypress="isLetter($event)"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            v-if="
              this.documentType != null && this.documentType.code === 'D.N.I.'
            "
          >
            <v-text-field
              filled
              label="Apellido materno"
              v-model="secondLastName"
              @keypress="isLetter($event)"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" v-else>
            <v-text-field
              filled
              label="Apellido materno (opcional)"
              v-model="secondLastName"
              @keypress="isLetter($event)"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-select
              :items="documentTypeList"
              v-model="documentType"
              label="Tipo de documento"
              filled
              return-object
              item-text="name"
              required
              :error-messages="documentTypeError"
              @input="$v.documentType.$touch()"
              @blur="$v.documentType.$touch()"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              ref="documentNumber"
              filled
              label="N.º de documento"
              v-model="documentNumber"
              required
              :error-messages="documentNumberError"
              @input="$v.documentNumber.$touch()"
              @blur="$v.documentNumber.$touch()"
              @keypress="isDocument($event)"
              :disabled="!documentType"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-select
              :items="genderList"
              v-model="gender"
              label="Género"
              filled
              return-object
              item-text="name"
              required
              :error-messages="genderError"
              @input="$v.gender.$touch()"
              @blur="$v.gender.$touch()"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="dateFormatted"
                  filled
                  label="Fecha de nacimiento"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                  :error-messages="dateError"
                  @input="$v.date2.$touch()"
                  @blur="$v.date2.$touch()"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                no-title
                @input="menu1 = false"
                :max="maxDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              filled
              label="Correo electrónico"
              v-model="email"
              required
              :error-messages="emailError"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              type="text"
              filled
              label="Celular"
              v-model="phoneNumber"
              required
              :error-messages="phoneNumberError"
              @input="$v.phoneNumber.$touch()"
              @blur="$v.phoneNumber.$touch()"
              @keypress="isPhoneNumber($event)"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-select
              :items="listDepartment"
              label="Departamento"
              filled
              return-object
              item-text="Value"
              :cache-items="false"
              v-model="department"
              :menu-props="{ bottom: true, offsetY: true }"
              @change="getProvince"
              no-data-text="No hay datos. Selecciona un Departamento"
              :loading="departmentLoading"
              required
              :error-messages="departmentError"
              @input="$v.department.$touch()"
              @blur="$v.department.$touch()"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12" md="6" class="no_padding">
            <v-select
              :items="listProvince"
              label="Provincia"
              filled
              return-object
              item-text="Value"
              :cache-items="false"
              v-model="province"
              :menu-props="{ bottom: true, offsetY: true }"
              @change="getDistrict"
              no-data-text="No hay datos. Selecciona un Departamento"
              :loading="provinceLoading"
              required
              :error-messages="provinceError"
              @input="$v.province.$touch()"
              @blur="$v.province.$touch()"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12" md="12" class="no_padding">
            <v-select
              :items="listDistrict"
              label="Distrito"
              filled
              return-object
              item-text="Value"
              :cache-items="false"
              v-model="district"
              :menu-props="{ bottom: true, offsetY: true }"
              no-data-text="No hay datos. Selecciona una Provincia"
              :loading="districtLoading"
              required
              :error-messages="districtError"
              @input="$v.district.$touch()"
              @blur="$v.district.$touch()"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12" md="12" class="no_padding">
            <v-select
              :items="social"
              label="¿Como te enteraste?"
              filled
              item-text="value"
              :cache-items="false"
              v-model="comoTeEnteraste"
              menu-props="auto"
              no-data-text="No hay datos. Selecciona una Opción"
              :loading="comoTeEnterasteLoading"
              required
              :error-messages="comoTeEnterasteError"
              @input="$v.comoTeEnteraste.$touch()"
              @blur="$v.comoTeEnteraste.$touch()"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            class="d-flex justify-end align-center user_register_terms"
          >
            <v-checkbox v-model="checkBoxTerms"></v-checkbox>
            <div class="ml-2">
              Acepto los
              <span @click="modalTerms = true">
                términos y condiciones
              </span>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-btn
              color="primary"
              class="btn-basic uppercase"
              @click="submit"
              :disabled="isDisabled"
              :loading="loading"
              >Registrar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
    <v-dialog v-model="modalTerms" persistent content-class="modalTerms">
      <v-card>
        <v-card-title class="titulo__dialog_img">
          <div class="flex-grow-1"></div>
          <v-btn icon @click="modalTerms = false" class="bottom-white">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="title__dialog">Términos y condiciones</div>
        <v-card-text class="terms">
          <vue-perfect-scrollbar
            class="drawer-menu--scroll"
            :settings="scrollSettings"
            @ps-y-reach-end="enableButton()"
          >
            <ul>
              <li v-for="(item, index) in listTerms" :key="index">
                <span class="text_li">{{ item }}</span>
              </li>
            </ul>
          </vue-perfect-scrollbar>
        </v-card-text>
        <v-card-actions
          style="display:flex;justify-content: center;margin: 0px 0;padding: 10px 0px 25px 0;"
        >
          <button
            class="btn--primary"
            style="max-width: 240px !important"
            v-bind:class="verifyLocked()"
            @click="
              modalTerms = false;
              checkBoxTerms = true;
              read = false;
            "
          >
            Ya lo leí
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { validationMixin } from "vuelidate";
import axios from "@/axios-auth";
import { mapMutations } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FormMessage from "@/components/common/FormMessage";
import moment from "moment";
moment.locale("es-do");

const { required, email } = require("vuelidate/lib/validators");

export default {
  components: {
    VuePerfectScrollbar,
    "form-message": FormMessage
  },
  data: vm => {
    return {
      loading: false,
      firstName: "",
      secondName: "",
      firstLastName: "",
      secondLastName: "",
      email: "",
      documentType: null,
      gender: null,
      documentNumber: "",
      phoneNumber: "",
      date: moment().format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),
      menu: false,
      message: null,

      date2: null,

      dateFormatted: null,
      menu1: false,

      documentTypeList: [
        { id: 1, code: "D.N.I.", name: "D.N.I." },
        { id: 2, code: "CE", name: "Carnet de extranjería" },
        { id: 3, code: "Pasaporte", name: "Pasaporte" },
        { id: 4, code: "Libreta Electoral", name: "Libreta Electoral" }
      ],
      genderList: [
        { id: 1, name: "Masculino" },
        { id: 2, name: "Femenino" }
      ],

      scrollSettings: {
        maxScrollbarLength: 160
      },
      listTerms: [
        "De conformidad con la Ley N° 29733 (en adelante, la Ley) y el Decreto Supremo N° 003-2013- JUS (en adelante, el Reglamento), la Universidad del Pacífico (en adelante la Universidad), le informa al usuario que sus datos personales que obran en poder de la Universidad y a los cuales se accede a través de esta aplicación, serán objeto de flujo transfronterizo a los países de Estados Unidos y Chile, con el propósito de procesar los datos y que la aplicación funcione adecuadamente.",
        "La Universidad declara que sus datos personales cuentan con todas las medidas de seguridad requeridas para su correcto tratamiento.",
        "Asimismo, el usuario autoriza que las imágenes en fotografía o video que opte por cargar en esta aplicación, también serán objeto de flujo transfronterizo. La Universidad procurará que estos no se vean afectados por cualquier uso indebido.",
        "En caso que el titular de los datos personales sea menor de edad entre catorce y dieciocho años, declara que lo descrito en este documento es comprensible; y, en función a ello, otorga su consentimiento para el flujo transfronterizo de sus datos personales, de conformidad con las finalidades descritas anteriormente.",
        "La Universidad informa a sus usuarios que sus datos personales serán conservados mientras sean necesarios para cumplir con las finalidades para las cuales se recopilaron.",
        "En caso que el usuario desee ejercer sus derechos de revocatoria de consentimiento, modificación o cualquier otro que se encuentra contemplado en la legislación de la materia, podrá recurrir a la oficina de Data Intelligence, la misma que se encuentra ubicada en Jirón Luis Sánchez Cerro N° 2141, distrito de Jesús María o escribir a revocatoria.alumnos.egresados@up.edu.pe."
      ],
      modalTerms: false,
      read: false,
      checkBoxTerms: false,
      listDepartment: [],
      listProvince: [],
      listDistrict: [],
      social: ["Facebook", "Google", "Instagram"],

      department: null,
      province: null,
      district: null,
      comoTeEnteraste: '',

      departmentLoading: false,
      provinceLoading: false,
      districtLoading: false,
      comoTeEnterasteLoading: false
    };
  },
  mounted() {
    this.getDepartment();
    this.loadOthers();
  },
  mixins: [validationMixin],
  validations: {
    firstName: { required },
    firstLastName: { required },
    documentType: { required },
    documentNumber: { required },
    gender: { required },
    date2: { required },
    email: { required, email },
    phoneNumber: { required },
    department: { required },
    province: { required },
    district: { required },
    comoTeEnteraste: { required }
  },
  methods: {
    ...mapMutations(["setUserData", "setResultRegister"]),
    formatDate2(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    messageClose() {
      this.message = null;
    },
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid && this.checkBoxTerms) {
        this.registerUser();
      }
    },
    loadOthers() {
      axios
        .get(`form/others/`)
        .then(response => {
          const others = response.data;
          if (others) {
            this.social = others.filter(o => o.attribute === "Referencia");
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    registerUser() {
      this.loading = true;

      let data = {
        first_name: this.firstName,
        second_name: this.secondName,
        first_surname: this.firstLastName,
        second_surname: this.secondLastName,
        document_type: this.documentType.code,
        document_number: this.documentNumber,
        gender: this.gender.id,
        birthdate: this.dateFormatted,
        email: this.email,
        mobile_phone: this.phoneNumber,
        idDepartamento: this.department.Key,
        idProvincia: this.province.Key,
        idDistrito: this.district.Key,
        comoTeEnteraste: this.comoTeEnteraste,
        AceptoTermsCond: this.checkBoxTerms ? "Acepto" : ""
      };

      this.setUserData(data);
      this.setResultRegister(null);
      axios
        .post(`users/register/`, data)
        .then(response => {
          this.setResultRegister(response.data);
          this.resetForm();
          this.loading = false;
          this.$emit("send");
          this.$router.push("/register");
        })
        .catch(err => {
          console.error(err.response.data.errors);
          this.loading = false;
          if (err.response.data.errors) {
            let errorArray = err.response.data.errors;
            for (const key in errorArray) {
              if (errorArray[key].length) {
                this.message = {
                  type: "error",
                  title: "Ocurrio un error al guardar",
                  subtitle: errorArray[key].join("<br>")
                };
              }
            }
          }
        });
    },
    enableButton() {
      this.read = true;
    },
    verifyLocked() {
      return this.read ? "" : "locked_button";
    },
    resetForm() {
      this.firstName = "";
      this.secondName = "";
      this.firstLastName = "";
      this.secondLastName = "";
      this.email = "";
      this.documentType = null;
      this.gender = null;
      this.documentNumber = "";
      this.phoneNumber = "";
      this.date = moment().format("YYYY-MM-DD");
      this.date2 = null;
      this.department = null;
      this.province = null;
      this.district = null;
      this.comoTeEnteraste = '';
      this.dateFormatted = null;
      this.checkBoxTerms = false;
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isNumber() {},
    isPhoneNumber(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      let selection = window
        .getSelection()
        .toString()
        .trim();
      if (selection.length > 0 && selection === this.phoneNumber) {
        this.phoneNumber = "";
      }
      if (
        (this.phoneNumber.length == 0 && char != 9) ||
        this.phoneNumber.length == 9
      ) {
        e.preventDefault();
      }
      if (/^[0-9]*$/.test(char)) return true;
      else e.preventDefault();
    },
    isDocument(e) {
      let char = String.fromCharCode(e.keyCode);
      let selection = window
        .getSelection()
        .toString()
        .trim();
      if (selection.length > 0 && selection === this.documentNumber) {
        this.documentNumber = "";
      }
      if (this.documentType) {
        if (this.documentType.id == 1 || this.documentType.id == 4) {
          // dni
          if (this.documentNumber.length == 8) e.preventDefault();

          if (/^[0-9][0-9]*$/.test(char)) return true;
          else e.preventDefault();
        } else if (this.documentType.id == 2 || this.documentType.id == 3) {
          if (this.documentNumber.length >= 12) e.preventDefault();
        } else {
          if (/^[0-9][0-9]*$/.test(char)) return true;
          else e.preventDefault();
        }
      } else {
        if (/^[0-9][0-9]*$/.test(char)) return true;
        else e.preventDefault();
      }
    },
    async getDepartment() {
      this.departmentLoading = true;
      this.department = null;
      const res = await axios({
        method: "post",
        url: "form/listar-departamento-por-id-pais/",
        data: {
          codigo: "0"
        },
      })
      this.listDepartment = res.data.detail;
      this.departmentLoading = false;
    },
    async getProvince() {
      this.provinceLoading = true;

      this.province = null;
      this.district = null;

      this.listProvince = [];
      this.listDistrict = [];

      const res = await axios({
        method: "post",
        url: "form/listar-provincia-por-id-departamento/",
        data: {
          codigo: this.department.Key
        },
      })

      this.listProvince = res.data.detail;
      this.provinceLoading = false;
    },
    async getDistrict() {
      this.districtLoading = true;

      const res = await axios({
        method: "post",
        url: "form/listar-distrito-por-id-provincia/",
        data: {
          codigo: this.province.Key
        },
      })

      this.listDistrict = res.data.detail;
      this.districtLoading = false;
    },
  },
  watch: {
    documentType(val) {
      if (val) {
        this.documentNumber = "";
        setTimeout(() => {
          this.$refs.documentNumber.focus();
        }, 500);
      }
    },
    date2(val) {
      this.dateFormatted = this.formatDate2(this.date2);
    }
  },
  computed: {
    firstNameError() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.required && errors.push("Este dato es requerido.");
      return errors;
    },
    firstLastNameError() {
      const errors = [];
      if (!this.$v.firstLastName.$dirty) return errors;
      !this.$v.firstLastName.required && errors.push("Este dato es requerido.");
      return errors;
    },
    documentTypeError() {
      const errors = [];
      if (!this.$v.documentType.$dirty) return errors;
      !this.$v.documentType.required && errors.push("Este dato es requerido.");
      return errors;
    },
    documentNumberError() {
      const errors = [];
      if (!this.$v.documentNumber.$dirty) return errors;
      !this.$v.documentNumber.required &&
        errors.push("Este dato es requerido.");
      if (this.documentType?.id) {
        this.documentType.id == 1 &&
        this.documentNumber.length < 8 &&
        errors.push("Ingrese un documento válido");
      this.documentType.id != 1 &&
        this.documentNumber.length < 11 &&
        errors.push("Ingrese un documento válido");
      }
      return errors;
    },
    genderError() {
      const errors = [];
      if (!this.$v.gender.$dirty) return errors;
      !this.$v.gender.required && errors.push("Este dato es requerido.");
      return errors;
    },
    dateError() {
      const errors = [];
      //console.log(this.$v.date2);
      if (!this.$v.date2.$dirty) return errors;
      !this.$v.date2 == null && errors.push("Este dato es requerido.");
      !this.$v.date2.required && errors.push("Este dato es requerido.");
      return errors;
    },
    emailError() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Ingrese un e-mail válido.");
      !this.$v.email.required && errors.push("Este dato es requerido.");
      return errors;
    },
    phoneNumberError() {
      const errors = [];
      if (!this.$v.phoneNumber.$dirty) return errors;
      !this.$v.phoneNumber.required && errors.push("Este dato es requerido.");
      return errors;
    },
    departmentError() {
      const errors = [];
      if (!this.$v.department.$dirty) return errors;
      !this.$v.department.required && errors.push("Este dato es requerido.");
      return errors;
    },
    provinceError() {
      const errors = [];
      if (!this.$v.province.$dirty) return errors;
      !this.$v.province.required && errors.push("Este dato es requerido.");
      return errors;
    },
    districtError() {
      const errors = [];
      if (!this.$v.district.$dirty) return errors;
      !this.$v.district.required && errors.push("Este dato es requerido.");
      return errors;
    },
    comoTeEnterasteError() {
      const errors = [];
      if (!this.$v.comoTeEnteraste.$dirty) return errors;
      !this.$v.comoTeEnteraste.required && errors.push("Este dato es requerido.");
      return errors;
    },
    isDisabled() {
      if (
        this.checkBoxTerms &&
        !this.firstNameError.length &&
        !this.firstLastNameError.length &&
        !this.documentTypeError.length &&
        !this.documentNumberError.length &&
        !this.genderError.length &&
        !this.dateError.length &&
        !this.emailError.length &&
        !this.phoneNumberError.length &&
        !this.departmentError.length &&
        !this.provinceError.length &&
        !this.districtError.length &&
        !this.comoTeEnterasteError.length
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>
